import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import getVar from "constants/.";

import "./style.scss";

interface IProps {
  match: any;
  userName: string;
  customerNumber: string;
}

class PDFViewer extends React.Component<IProps> {
  public render() {
    const {
      match: { params },
      userName,
      customerNumber
    } = this.props;
    const url = `${getVar("LOCAL_API_URI")}/teeltadvies/file/${
      params.id
    }/?text=${userName} (${customerNumber})`;

    return (
      <div id="pdf-viewer">
        <object data={url} type="application/pdf" width="100%" height="100%">
          <p>
            <FormattedMessage id="PDF_NOT_SUPPORT" />
            <a href={url}>
              <FormattedMessage id="PDF_DOWNLOAD" />
            </a>
          </p>
        </object>
      </div>
    );
  }
}

export default connect(state => ({
  userName: state.app.userName,
  customerNumber: state.app.currentCustomer.Number
}))(PDFViewer);
